import React from 'react'
import { useParams } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import DashboardContentWrapper from '@/shared/components/dashboard-content-wrapper'
import { getHomeOwner, getHome } from '@/features/homeowners/api/homeowners.api'
import BackButton from '@/features/homeowners/components/back-button'
import HomeownerDetailsTabs from '@/features/homeowners/components/homeowner-details-tabs'
import HomeownerDetailHeading from '@/features/homeowners/components/homeowner-detail-heading'

function HomeOwnerDetailsPage() {
  const { homeownerId: homeownerIdString } = useParams()
  const homeOwnerId = parseInt(homeownerIdString || '', 10)

  // Fetch homeowner details
  const { data: homeownerRes, isLoading: isHomeownerLoading, error: homeownerError } = useQuery({
    queryKey: ['homeowners', 'detail', homeOwnerId],
    queryFn: () => getHomeOwner(homeOwnerId),
    enabled: !Number.isNaN(homeOwnerId),
  })

  const homeOwner = homeownerRes?.success ? homeownerRes.data : null
  const homeId = homeOwner?.home?.id

  // Fetch home details if homeowner has a home
  const { data: homeRes, isLoading: isHomeLoading } = useQuery({
    queryKey: ['homes', 'detail', homeId],
    queryFn: () => getHome(homeId!),
    enabled: !!homeId,
  })

  const home = homeRes?.success ? homeRes.data : null

  if (Number.isNaN(homeOwnerId)) {
    return (
      <DashboardContentWrapper>
        <BackButton />
        <div className="text-destructive mt-5">Invalid homeowner ID</div>
      </DashboardContentWrapper>
    )
  }

  if (isHomeownerLoading) {
    return (
      <div className="flex h-64 w-full items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    )
  }

  if (homeownerError || !homeownerRes || !homeownerRes.success || !homeOwner) {
    return (
      <DashboardContentWrapper>
        <BackButton />
        <div className="text-destructive mt-5">
          {(!homeownerRes || !homeownerRes.success) 
            ? (homeownerRes as any)?.message 
            : 'Failed to load homeowner details'}
        </div>
      </DashboardContentWrapper>
    )
  }

  return (
    <DashboardContentWrapper className="space-y-5 pb-24 md:pb-5">
      <div className="flex items-center gap-0.5">
        <BackButton />
        <HomeownerDetailHeading fullname={homeOwner.user.fullname} homeownerUserId={homeOwner.user?.id} />
      </div>

      <HomeownerDetailsTabs homeOwner={homeOwner} home={home} />
    </DashboardContentWrapper>
  )
}

export default HomeOwnerDetailsPage
